export const MIN_VALUE_STEPPER = '1';
